import React from "react";
import { Menu, Dropdown, Layout, Button, Typography, Drawer, Grid } from "antd";
import {
  DownOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom"; // Add useLocation

const { Header } = Layout;
const { Text } = Typography;

const AdminNavbar = ({ userName = "Admin", onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleMenuClick = (e) => {
    if (e.key === "logout") {
      if (onLogout) onLogout();
      else {
        localStorage.removeItem("token");
        window.location.reload();
      }
    } else {
      navigate(e.key);
    }
    // Close drawer on mobile after navigation
    if (isMobile) setMobileOpen(false);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  // List of menu items and their keys
  const menuItems = [
    { key: "/AdminDashBoard", label: "Dashboard" },
    { key: "/AdminCategory", label: "Manage Product" },
    { key: "/NewLaunch", label: "New Launch" }, // <-- Added
    { key: "/ManageNewArrival", label: "Manage New Arrival" },
    { key: "/ManageProductTags", label: "Product Tags" },
    { key: "/ManageLastChanceDeals", label: "LastChance Deal Items" },
    { key: "/ManageTrendingItems", label: "Trending Items" },
    { key: "/UserList", label: "User List" },
    { key: "/UserActivitySummary", label: "Activity Summary" },
    { key: "/InstaPostSchedule", label: "Insta Post Schedule" },
    // Add CRM submenu
    {
      key: "crm",
      label: "CRM",
      children: [
        { key: "/LeadsToApprove", label: "Leads To Approve" },
        // Add more CRM submenu items here if needed
      ],
    },
  ];

  const flatKeys = menuItems.flatMap((it) =>
    it.children ? it.children.map((c) => c.key) : [it.key]
  );
  const selectedKey =
    flatKeys.find((k) => location.pathname.startsWith(k)) || "";

  const defaultOpenKeys = React.useMemo(() => {
    const crmChildKeys = (
      menuItems.find((m) => m.key === "crm")?.children || []
    ).map((c) => c.key);
    return crmChildKeys.some((k) => selectedKey.startsWith(k)) ? ["crm"] : [];
  }, [selectedKey]);

  return (
    <Header
      style={{
        background: "#fff",
        padding: isMobile ? "0 12px" : "0 24px",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #f0f0f0",
        height: 56,
        zIndex: 100,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        {isMobile ? (
          <>
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ marginRight: 8 }}
            >
              Menu
            </Button>
          </>
        ) : (
          <Menu
            mode="horizontal"
            selectedKeys={[selectedKey]}
            style={{ borderBottom: "none", flex: 1, minWidth: 0 }}
            onClick={handleMenuClick}
          >
            {menuItems.map((item) =>
              item.children ? (
                <Menu.SubMenu key={item.key} title={item.label}>
                  {item.children.map((child) => (
                    <Menu.Item key={child.key}>{child.label}</Menu.Item>
                  ))}
                </Menu.SubMenu>
              ) : (
                <Menu.Item key={item.key}>{item.label}</Menu.Item>
              )
            )}
          </Menu>
        )}
      </div>

      <Dropdown overlay={menu} trigger={["click"]}>
        <Button
          type="text"
          icon={<UserOutlined />}
          style={{ fontWeight: 500, fontSize: 16 }}
        >
          <span style={{ marginRight: 4 }}>{userName}</span>
          <DownOutlined />
        </Button>
      </Dropdown>

      {/* Mobile drawer menu */}
      <Drawer
        title="Admin Menu"
        placement="left"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={defaultOpenKeys}
          onClick={handleMenuClick}
          style={{ borderRight: 0 }}
          items={menuItems.map((item) =>
            item.children
              ? {
                key: item.key,
                label: item.label,
                children: item.children.map((c) => ({
                  key: c.key,
                  label: c.label,
                })),
              }
              : { key: item.key, label: item.label }
          )}
        />
      </Drawer>
    </Header>
  );
};

export default AdminNavbar;
